/*
 * Developed for EPSON AMERICA INC. by Softeq Development Corporation
 * http://www.softeq.com
 */

import React from 'react'
import { Text } from 'hocs/localization'
import HomeLayout from 'apps/HomeLayout'
import Banner from './apps/Banner'
import PartnerPrinting from './apps/PartnerPrinting'
import HowToWork from './apps/HowToWork'
import Benefits from './apps/Benefits'
import SelectPlan from './apps/SelectPlan'
import ComparePlans from './apps/ComparePlans'
import Question from './apps/Question'
import ScrollUpButton from './apps/ScrollUpButton'

interface IProps {
  t: Text,
  trackVideoPlay(): void,
}

const Main: React.FC<IProps> = ({trackVideoPlay}) => (
  <HomeLayout>
    <Banner />
    <PartnerPrinting trackVideoPlay={trackVideoPlay} />
    <SelectPlan />
    <Benefits />
    <HowToWork />
    <ComparePlans />
    <Question />
    <ScrollUpButton />
  </HomeLayout>
)

export default Main
